// import { oidc } from 'services/oidcService';
// import { callApi } from './callApi';

export enum CampaignCategory {
    MERCHANDISING = 'merchandising',
    CRM = 'crm',
}

export const CampaignCategoryHumanizedNames = {
    [CampaignCategory.MERCHANDISING]: 'Merchandising',
    [CampaignCategory.CRM]: 'CRM',
};

export enum VendorCampaignStatus {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    UNPUBLISHED = 'unpublished',
}

export enum AyceOfferStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export type AyceCampaignsDto = {
    campaignId: string;
    name: string;
    startDate: string; // ISO, UTC
    endDate: string; // ISO, UTC
    category: CampaignCategory;
    vendorCampaignList: Array<{ vendorName: string; status: VendorCampaignStatus }>;
};

export interface AyceOffer {
    voucherId: string;
    discountId: string;
    productBlockTitle: string;
    checkoutLabel: string;
    imagePath: string;
    voucherPrice: number;
    productPrice: number;
    currency: string;
    includedOptions: string[];
    excludedOptions: string[];
    startDate: string;
    expirationDate: string;
    status: AyceOfferStatus;
}

export type AyceVendorCampaign = {
    campaignId: string;
    vendorName: string;
    offers: AyceOffer[];
    pageDetails: {
        title: string;
        subtitle: string;
    };
    attributions: [
        {
            category: CampaignCategory;
            id: string;
        },
    ];
    status: VendorCampaignStatus;
};

export type AyceCampaignDto = {
    campaignId: string;
    name: string;
    startDate: string;
    endDate: string;
    category: CampaignCategory;
    vendorCampaignList: AyceVendorCampaign[];
};

export const getAyceCampaigns = async (): Promise<AyceCampaignsDto[]> => {
    // const token = await oidc.getAccessToken();
    // const result = await callApi('VoucherApiUrl', 'GET', 'campaigns', null, {}, token);
    await new Promise(resolve => {
        setTimeout(() => {
            resolve(true);
        }, 500);
    });
    return [
        {
            campaignId: '1',
            name: 'Mock Campaign',
            startDate: '2023-01-01T00:00:00.000Z',
            endDate: '2025-01-01T00:00:00.000Z',
            category: CampaignCategory.MERCHANDISING,
            vendorCampaignList: [
                {
                    vendorName: 'albelli.nl',
                    status: VendorCampaignStatus.DRAFT,
                },
                {
                    vendorName: 'albelli.be',
                    status: VendorCampaignStatus.PUBLISHED,
                },
                {
                    vendorName: 'fotoknudsen.no',
                    status: VendorCampaignStatus.UNPUBLISHED,
                },
            ],
        },
        {
            campaignId: '2',
            name: 'Mock Expired',
            startDate: '2022-01-01T00:00:00.000Z',
            endDate: '2023-01-01T00:00:00.000Z',
            category: CampaignCategory.CRM,
            vendorCampaignList: [
                {
                    vendorName: 'photobox.co.uk',
                    status: VendorCampaignStatus.DRAFT,
                },
                {
                    vendorName: 'photobox.fr',
                    status: VendorCampaignStatus.PUBLISHED,
                },
                {
                    vendorName: 'onskefoto.se',
                    status: VendorCampaignStatus.UNPUBLISHED,
                },
            ],
        },
        {
            campaignId: '3',
            name: 'Mock Expired 2',
            startDate: '2022-01-01T00:00:00.000Z',
            endDate: '2023-01-01T00:00:00.000Z',
            category: CampaignCategory.MERCHANDISING,
            vendorCampaignList: [
                {
                    vendorName: 'albelli.nl',
                    status: VendorCampaignStatus.DRAFT,
                },
                {
                    vendorName: 'albelli.be',
                    status: VendorCampaignStatus.PUBLISHED,
                },
                {
                    vendorName: 'fotoknudsen.no',
                    status: VendorCampaignStatus.UNPUBLISHED,
                },
            ],
        },
    ];
};

export const getAyceCampaign = async (campaignId: string): Promise<AyceCampaignDto> => {
    // const token = await oidc.getAccessToken();
    // return await callApi('VoucherApiUrl', 'GET', `campaigns/${campaignId}`, null, {}, token);
    await new Promise(resolve => {
        setTimeout(() => {
            resolve(true);
        }, 500);
    });

    const mockOffers = [
        {
            voucherId: '1',
            discountId: 'a393f0b7-5e00-4343-9f13-12aeed4e564c',
            imagePath: 'content/seo-pages/images/3f99cc2a119992eff72412875e847a74-1696255129982-yoyhs.jpg',
            productBlockTitle: 'title 1',
            checkoutLabel: 'checkout',
            productPrice: 59.99,
            expirationDate: '2024-05-25T10:30:00.000Z',
            voucherPrice: 25,
            status: AyceOfferStatus.ACTIVE,
        },
        {
            voucherId: '2',
            discountId: '6728c00f-3454-4e00-ae89-1c010e0201bd',
            imagePath: 'content/seo-pages/images/frog-1699971083537-bceg8.jpeg',
            productBlockTitle: 'title 2',
            checkoutLabel: 'checkout 2',
            productPrice: 120,
            expirationDate: '2024-05-27T10:30:00.000Z',
            voucherPrice: 59.99,
            status: AyceOfferStatus.INACTIVE,
        },
    ];

    return {
        campaignId,
        name: 'Mock Campaign',
        startDate: '2024-01-02T10:30:00.000Z',
        endDate: '2024-05-20T10:30:00.000Z',
        category: 'crm',
        vendorCampaignList: [
            {
                vendorName: 'albelli.nl',
                status: VendorCampaignStatus.DRAFT,
                offers: mockOffers,
            },
            {
                vendorName: 'albelli.be',
                status: VendorCampaignStatus.PUBLISHED,
                offers: mockOffers,
            },
            {
                vendorName: 'fotoknudsen.no',
                status: VendorCampaignStatus.UNPUBLISHED,
                offers: mockOffers,
            },
        ] as AyceVendorCampaign[],
    } as AyceCampaignDto;
};
